import { queryClient } from "."

const fn = queryClient.invalidateQueries
export type InvalidateQueriesOptions = Parameters<typeof fn>
export const invalidateAllQueries = (...args: InvalidateQueriesOptions) => {
  queryClient.invalidateQueries(...args)
}
